import React, { useEffect, useState } from "react";
import { McModal } from "@maersk-global/mds-react-wrapper/mc-modal";
import Select from "react-select";
import apiClient from "../api/apiClient";
import { Button } from "@mui/material";
import { apiUrl } from "../authconfig";
const BulkStatusModel = (props) => {
  const [status, setStatus] = useState(['Cancelled','Not in Current Scope']);
  const [selectedUser, setSelectedUser] = useState();
  const [comment,setComment] = useState();
  const [cancelReason ,setCancelReason] = useState();
  const [notInCurrentScopeReason ,setNotInCurrentScopeReason] = useState();
  const currentUser = JSON.parse(sessionStorage.getItem("user"));


  const handleSubmit = () => {
    const selectedRowId = props.rowSelectionModel;
    const data = props.rows;
    const selectedRow = data?.filter((item) =>
      selectedRowId?.includes(item?.id)
    );

    const payload = selectedRow.map((item) => {
      return { ...item, projectStatus: selectedUser?.value,additionalComments:comment,modifiedBy: currentUser?.mail,detailReasonForNotOnTrack:'NA',
         projectSubstatus : selectedUser?.value == 'Cancelled' ? cancelReason?.value :  notInCurrentScopeReason?.value ,
       };
    });
    console.log("payload", payload);

    apiClient
      .post(`${apiUrl}/api/opportunities/saveOpportunities`, payload)
      .then((response) => {
        props.handleClose();
        props.setBulkStatusModal(false);
        props.setRowSelectionModel([]);
      })
      .catch((error) => {
        alert(error.response.data || "Something went wrong");
      });
  };

  const handleUserAssign = (value) => {
    setSelectedUser(value);
  };


  console.log("rowSelectionModel", selectedUser);
  return (
    <div>
      <McModal
        closed={() => {
          props.setBulkStatusModal(false);
        }}
        open={props.bulkStatusModel}
        width="50vw"
        height="50vh"
      >
        <div
          style={{
            marginBottom: "20px",
            background: "rgb(66, 176, 213)",
            color: "#fff",
            justifyContent: "space-evenly",
            borderRadius: "5px",
          }}
        >
          <p
            style={{
              fontSize: "16px",
              margin: "5px",
              fontFamily: "Maersk Text",
            }}
          >
            <b>Change Status</b>
          </p>
        </div>

        <div>
          <Select
            options={status.map((item) => ({
              value: item,
              label: item,
            }))}
            placeholder="Status List"
            isClearable
            value={selectedUser}
            onChange={(value) => handleUserAssign(value)}
          />
        </div>
        {selectedUser?.value == 'Cancelled' &&<div style={{marginTop:'20px'}}>
          <Select
            options={['Close lost (business lost)','Non-existing opportunity'].map((item) => ({
              value: item,
              label: item,
            }))}
            placeholder="Status List"
            isClearable
            value={cancelReason}
            onChange={(value) => setCancelReason(value)}
          />
        </div>}

         {selectedUser?.value == 'Not in Current Scope' &&<div style={{marginTop:'20px'}}>
          <Select
            options={['Renewal (existing deal/volume increase)',
              'Incorrect SFDC opportunity details',
              'CIM - picked up by CIM',
              'CPM - picked up by CPM',
              'TbM Ops (Delivery), FbM, MPL, etc. scope'].map((item) => ({
              value: item,
              label: item,
            }))}
            placeholder="Status List"
            isClearable
            value={notInCurrentScopeReason}
            onChange={(value) => setNotInCurrentScopeReason(value)}
          />
        </div>}

        <div style={{marginTop:'40px',display:'flex',flexDirection:'column'}}>
        <textarea
              rows={5}
              style={{ width: "-webkit-fill-available" }}
              name="additionalComments"
              value={comment || ""}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Enter Comments for Status change"
            />
        </div>
        <div style={{ marginTop: "20px" }}>
          <Button
            variant="contained"
            style={{
              display: "block",
              margin: "20px auto",
              justifyItems: "center",
              width: "150px",
              padding: "10px",
              backgroundColor:  ( !selectedUser || (selectedUser?.value == 'Cancelled' && !cancelReason) || (selectedUser?.value == 'Not in Current Scope' && !notInCurrentScopeReason)) ? "lightgrey" : "#00243D",
            }}
            onClick={() => handleSubmit()}
            disabled={ !selectedUser || (selectedUser?.value == 'Cancelled' && !cancelReason) || (selectedUser?.value == 'Not in Current Scope' && !notInCurrentScopeReason)} 
          >
            Submit
          </Button>
        </div>
      </McModal>
    </div>
  );
};

export default BulkStatusModel;
